import moment from 'moment'
import { DateRange } from './types'
export const createDateRange = (label: string): DateRange => {
  const today = new Date()
  const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0)
  const endOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999)

  switch (label) {
    case 'All':
      return {
        from: null,
        to: null,
        label: 'All'
      }
    case 'Today':
      return {
        from: startOfToday,
        to: endOfToday,
        label: 'Today'
      }
    case 'Yesterday': {
      const yesterday = new Date(today)
      yesterday.setDate(today.getDate() - 1)
      const startOfYesterday = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0, 0)
      const endOfYesterday = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59, 999)
      return {
        from: startOfYesterday,
        to: endOfYesterday,
        label: 'Yesterday'
      }
    }
    case '-2 days': {
      const twoDaysAgo = new Date(today)
      twoDaysAgo.setDate(today.getDate() - 2)
      const startOfTwoDaysAgo = new Date(twoDaysAgo.getFullYear(), twoDaysAgo.getMonth(), twoDaysAgo.getDate(), 0, 0, 0, 0)
      const endOfTwoDaysAgo = new Date(twoDaysAgo.getFullYear(), twoDaysAgo.getMonth(), twoDaysAgo.getDate(), 23, 59, 59, 999)
      return {
        from: startOfTwoDaysAgo,
        to: endOfTwoDaysAgo,
        label: '-2 days'
      }
    }
    case '-3 days': {
      const threeDaysAgo = new Date(today)
      threeDaysAgo.setDate(today.getDate() - 3)
      const startOfThreeDaysAgo = new Date(threeDaysAgo.getFullYear(), threeDaysAgo.getMonth(), threeDaysAgo.getDate(), 0, 0, 0, 0)
      const endOfThreeDaysAgo = new Date(threeDaysAgo.getFullYear(), threeDaysAgo.getMonth(), threeDaysAgo.getDate(), 23, 59, 59, 999)
      return {
        from: startOfThreeDaysAgo,
        to: endOfThreeDaysAgo,
        label: '-3 days'
      }
    }
    default:
      return {
        from: startOfToday,
        to: endOfToday,
        label: 'Today'
      }
  }
}

export const generateDateOptions = () => {
  const today = moment()

  return [
    {
      id: 'all',
      label: 'All',
      date: 'All dates'
    },
    {
      id: 'today',
      label: 'Today',
      date: today.format('ddd, DD MMM')
    },
    {
      id: 'yesterday',
      label: 'Yesterday',
      date: today.clone().subtract(1, 'day').format('ddd, DD MMM')
    },
    {
      id: 'minus2',
      label: '-2 days',
      date: today.clone().subtract(2, 'days').format('ddd, DD MMM')
    },
    {
      id: 'minus3',
      label: '-3 days',
      date: today.clone().subtract(3, 'days').format('ddd, DD MMM')
    }
  ]
}